import { useTranslation } from "react-i18next"

import { baseColumnDef } from "@/nzds/data-grid"
import { formatTimezone } from "@/utils/date"

import type { GridColDef, GridValidRowModel } from "@mui/x-data-grid-pro"

interface UseTimezoneColumnOptions {
  field?: string
  filterable?: boolean
  timeZone: string
}

export const useTimezoneColumn = <TRow extends GridValidRowModel>(
  options: UseTimezoneColumnOptions
): GridColDef<TRow> => {
  const { t } = useTranslation("common")
  const field = options.field ?? "timezone"
  const filterable = options.filterable ?? false
  const { timeZone } = options

  return {
    ...baseColumnDef,
    field,
    filterable,
    flex: 1,
    headerName: t("fields.timezone.title"),
    maxWidth: 240,
    minWidth: 140,
    sortable: false,
    valueFormatter: (value: string | null | undefined) => formatTimezone(value),
    valueGetter: () => timeZone,
  }
}
